import { render, staticRenderFns } from "./JA.vue?vue&type=template&id=07b232cf&scoped=true&lang=html&"
import script from "./JA.vue?vue&type=script&lang=js&"
export * from "./JA.vue?vue&type=script&lang=js&"
import style0 from "./JA.vue?vue&type=style&index=0&id=07b232cf&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b232cf",
  null
  
)

export default component.exports